export default __webpack_public_path__ + "static/media/DSC07661.9f67ff2c.JPG";